module.exports = __webpack_public_path__ + "img/523.29f3420f.png";